module.exports = __webpack_public_path__ + "img/forecast_table.58b31c47.png";